"use client";
const x = Object.freeze({
  lg: "0 4px 6px -1px #0000001a ",
  md: "0 1px 3px 0 #0000001a ",
  sm: "0 1px 2px 0 #0000000d ",
  xl: "0 10px 15px -3px #0000001a "
}), p = Object.keys(x);
export {
  x as SHADOWS,
  p as SHADOW_KEYS
};
